import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import { getImageWithWidth, getSrcSet } from 'utils/images';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';
import Cover from 'menus/ui_components/Cover';

const styles = theme => ({
  hero: {
    height: 352,
    position: 'relative',
    backgroundColor: ({ heroBackground }) => heroBackground,
    [theme.breakpoints.down('md')]: {
      height: 260
    }
  },
  heroImage: { width: '100%', objectFit: 'cover', height: '100%' }
});

const FULL_WIDTH_SIZES = [640, 750, 900, 1536, 2048, 2560];
const Hero = ({ src, alt, classes, children, dataTestId }) => {
  const resizedImage = getImageWithWidth(src, 600);
  const srcSet = getSrcSet(src, FULL_WIDTH_SIZES);
  return (
    <div className={classes.hero} data-testid={dataTestId}>
      {src && (
        <Cover>
          <img
            srcSet={srcSet}
            src={resizedImage}
            alt={alt}
            sizes="100vw"
            className={classes.heroImage}
          />
        </Cover>
      )}
      {children}
    </div>
  );
};

Hero.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  dataTestId: PropTypes.string,
  classes: PropTypes.shape({}),
  children: CHILDREN_PROPTYPES
};
Hero.defaultProps = {
  dataTestId: 'hero'
};
export default withStyles(styles)(Hero);
